/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2022-03-08 14:11:53
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginTooltip from 'bee-tooltip';
import { Tooltip as OriginTooltip } from '@tinper/next-ui';
import { getSysFieldid, microAppUtil } from '@platform/api';

//require('bee-tooltip/build/Tooltip.css');
require('./index.less');

export default class Tooltip extends Component {
    constructor(props){
        super(props);
        this.defaultBody = microAppUtil.getDocument();
    }
    render() {
        let {
            className,
            container,
            getPopupContainer,
            mouseEnterDelay,
            mouseLeaveDelay,
            delay,
            delayShow,
            delayHide,
            ...others
        } = this.props;
        //兼容container YBP-SCM-BUG-13777
        let newContainer = typeof container === 'function' ? container : container && (() => { return container; });
        getPopupContainer = newContainer || getPopupContainer || (() => this.defaultBody);
        // 秒级
        mouseEnterDelay ??= (delayShow ?? delay ?? 500) / 1000;
        mouseLeaveDelay ??= (delayHide ?? delay ?? 100) / 1000;
        return <OriginTooltip
            inverse
            overlayClassName={`${getSysFieldid('fieldid_tips-window')} ${className + ' base-nc-tooltip'}`}
            getPopupContainer={getPopupContainer}
            mouseEnterDelay={mouseEnterDelay}
            mouseLeaveDelay={mouseLeaveDelay}
            {...others}
        />;
    }
}
